var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPalette(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 4C1 2.34315 2.34315 1 4 1H8C9.65685 1 11 2.34315 11 4V5.92905L13.1214 3.80765C14.293 2.63608 16.1925 2.63608 17.364 3.80765L20.1925 6.63608C21.364 7.80765 21.364 9.70714 20.1925 10.8787L18.0712 13H20C21.6569 13 23 14.3431 23 16V20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20V4ZM10.8293 21H20C20.5523 21 21 20.5523 21 20V16C21 15.4477 20.5523 15 20 15H16.0712L10.9992 20.072C10.9915 20.3967 10.9323 20.7087 10.8293 21ZM11 17.2428L18.7783 9.4645C19.1688 9.07398 19.1688 8.44081 18.7783 8.05029L15.9498 5.22186C15.5593 4.83134 14.9261 4.83134 14.5356 5.22186L11 8.75747V17.2428ZM8 21C8.55228 21 9 20.5523 9 20V4C9 3.44772 8.55228 3 8 3H4C3.44772 3 3 3.44772 3 4V20C3 20.5523 3.44772 21 4 21H8ZM6 16C6.55228 16 7 16.4477 7 17V18C7 18.5523 6.55228 19 6 19C5.44772 19 5 18.5523 5 18V17C5 16.4477 5.44772 16 6 16Z",
    fill: "#5C6278"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalette);
export default __webpack_public_path__ + "static/media/palette.f2800123d6f0a11f29fafdd34081fe73.svg";
export { ForwardRef as ReactComponent };